import {Exclude, Expose, Type} from 'class-transformer';
import {AbstractApiModel} from './abstract.api.model';
import {HyperlinkApiModel} from './hyperlink.api-model';
import {MediaObjectInterface} from "../../core/interfaces/media-object.interface";

@Exclude()
export class DocumentApiModel extends AbstractApiModel implements MediaObjectInterface {

  @Expose() public name: string;
  @Expose() public size: string;
  @Expose() public mimeType: string;
  @Expose() public originalName: string;
  @Expose() public dimensions: number[];
  @Expose() public description: string;
  @Expose() public type: string;
  @Expose() public file: File;
  @Expose() public thumbnail: string;
  @Expose() public createdAt: Date;
  @Expose()
  @Type(() => HyperlinkApiModel)
  public hyperlinks: HyperlinkApiModel[];
  @Expose() public uploadedBy: string[];
  @Expose() public processingStatus?: 'pending_upload' | 'uploaded' | 'processing' | 'completed' | 'failed';
  @Expose() public processingError?: string;
  public isPlaceholder: boolean = false;
}
